module.exports = __webpack_public_path__ + "static/img/preview-6.f94d6e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/preview/zombs/preview-6.png
// module id = 1Ie2
// module chunks = 35